module.exports = __webpack_public_path__ + "static/img/rank_216.7593517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_216.png
// module id = Mfmd
// module chunks = 0